module.exports = __webpack_public_path__ + "static/media/LNE7_EDITSINGLE.3289d6c3.mp4";